import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { MarketProductItem } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type RecommendProductsResponse = MarketProductItem[];

// Request 타입 (recommend category-items 쿼리 파라미터)
// 명명된 OAISchema 스키마가 없어 엔드포인트 query 파라미터를 로컬 타입으로 정의한다.
export type RecommendCategoryItemRequest = {
  offerIds: number[];
};

export interface RecommendDataSource {
  // 홈 - 구매한 상품의 연관상품 추천
  getHomeCategoryItems(): Promise<RecommendProductsResponse>;
  // 분류 기반 연관상품 추천 (offerIds 기반)
  getCategoryItems(
    request: RecommendCategoryItemRequest,
  ): Promise<RecommendProductsResponse>;
  // 업종별 인기상품 추천
  getClassificationItems(): Promise<RecommendProductsResponse>;
}

export class RecommendDataSourceImpl implements RecommendDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getHomeCategoryItems() {
    return this.client.request<RecommendProductsResponse>({
      url: '/api/market-place/v1/recommend/home-category-items',
      method: 'get',
    });
  }

  async getCategoryItems(request: RecommendCategoryItemRequest) {
    return this.client.request<RecommendProductsResponse>({
      url: '/api/market-place/v1/recommend/category-items',
      method: 'get',
      params: { ...request },
    });
  }

  async getClassificationItems() {
    return this.client.request<RecommendProductsResponse>({
      url: '/api/market-place/v1/recommend/classification-items',
      method: 'get',
    });
  }
}

export const recommendDataSource = new RecommendDataSourceImpl();
